module.exports = __webpack_public_path__ + "static/media/xwing.6354c561.png";